import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

export async function getGoogleClasses(): Promise<any> {
  const { data, error } = await supabase.functions.invoke(
    "getGoogleClassroomClasses",
    {
      body: {},
    }
  );

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();
    return { data: null, error: errorMessage.error };
  }

  return {
    data: data?.data || null,
    error: error?.message || null,
  };
}
